import { type ReactElement, type MouseEvent as ReactMouseEvent } from 'react';
import { NeonButtonFooter, NeonModalDialog } from '@ps-refarch-ux/neon';
import { NeonButtonTypes } from '@/constants/neon-constants';
import styles from './create-plan-modal.module.scss';

export interface DeletePlanModalProps {
  isOpen: boolean;
  modalId: string;
  planName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export function DeletePlanModal({
  isOpen,
  modalId,
  planName,
  onClose,
  onConfirm,
  isDeleting = false,
}: DeletePlanModalProps): ReactElement | null {
  if (!isOpen) {
    return null;
  }

  return (
    <NeonModalDialog id={modalId} neonDialogHasClosed={onClose} dataSize="small">
      <div data-slot="dialog-header-title">Delete plan of study?</div>
      <div
        className={styles.body}
        data-slot="dialog-body"
        aria-label={`Delete plan of study?: ${planName}. Deleting this plan of study will permanently remove it. This action cannot be undone.`}
      >
        <p>Deleting this plan of study will permanently remove it. This action cannot be undone.</p>
      </div>
      <div data-slot="dialog-button-footer">
        <NeonButtonFooter
          id="delete-plan-modal-footer"
          buttons={[
            {
              id: 'delete-plan-cancel',
              text: 'Cancel',
              type: NeonButtonTypes.Borderless,
              onClick: (event: Event | ReactMouseEvent) => {
                const target = (event?.target ?? (event as ReactMouseEvent)?.currentTarget) as
                  | HTMLElement
                  | undefined;
                target?.dispatchEvent(new Event('neonDialogClose', { bubbles: true }));
              },
            },
          ]}
          primaryButton={{
            id: 'delete-plan-confirm',
            text: 'Delete plan of study',
            type: NeonButtonTypes.Tertiary,
            disabled: isDeleting,
            onClick: onConfirm,
          }}
        />
      </div>
    </NeonModalDialog>
  );
}
